import { Card, CardContent } from "@/components/ui/card";
import { TrendingUp, TrendingDown } from "lucide-react";

const formatDKK = (amount) =>
  new Intl.NumberFormat("da-DK", {
    style: "currency", currency: "DKK",
    minimumFractionDigits: 0, maximumFractionDigits: 0,
  }).format(amount);

export const KPICard = ({ label, value, subtitle, trend, icon: Icon, delay = 0, diffAmount, diffLabel }) => {
  const trendUp = trend && trend > 0;
  const diffUp = diffAmount != null && diffAmount > 0;
  const diffDown = diffAmount != null && diffAmount < 0;
  const showDiff = diffAmount != null && diffLabel && diffAmount !== 0;

  return (
    <Card
      className={`bg-card border-border shadow-none hover:border-border transition-colors duration-200 animate-fade-in-up opacity-0 stagger-${delay}`}
      data-testid={`kpi-card-${label.toLowerCase().replace(/\s/g, "-")}`}
    >
      <CardContent className="p-4 sm:p-6">
        <div className="flex items-start justify-between mb-4">
          <span className="label-overline text-muted-foreground">{label}</span>
          {Icon && (
            <div className="p-2 rounded-lg bg-secondary">
              <Icon className="w-4 h-4 text-[#FF2A6D]" />
            </div>
          )}
        </div>
        <div className="font-kpi text-2xl sm:text-4xl text-foreground mb-1 leading-tight break-words [overflow-wrap:anywhere] tabular-nums" data-testid={`kpi-value-${label.toLowerCase().replace(/\s/g, "-")}`}>
          {value}
        </div>
        <div className="flex flex-col gap-0.5">
          <div className="flex items-center gap-2">
            {subtitle && (
              <span className="text-[13px] text-muted-foreground">{subtitle}</span>
            )}
            {trend !== undefined && trend !== null && (
              <span
                className={`flex items-center gap-0.5 text-[13px] font-medium ${
                  trendUp ? "text-emerald-600 dark:text-emerald-400" : "text-red-600 dark:text-red-400"
                }`}
              >
                {trendUp ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                {Math.abs(trend)}%
              </span>
            )}
          </div>
          {showDiff && (
            <div className={`flex items-center gap-1 text-[12px] font-medium ${diffUp ? "text-emerald-500" : diffDown ? "text-red-500" : "text-muted-foreground"}`}>
              {diffUp ? <TrendingUp className="w-3 h-3 shrink-0" /> : <TrendingDown className="w-3 h-3 shrink-0" />}
              <span>
                {diffUp ? "+" : ""}{formatDKK(diffAmount)} {diffLabel}
              </span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
